const URLs = {
  API: "https://kongumatrimony.co.in",
  // API: "http://localhost:4000",
};

export default URLs;
